import { createSlice } from '@reduxjs/toolkit';
import { mergeReduxStateData } from 'library/helpers/reduxHelpers';

const initialState = {
	data: {},
	timeStamp: null,
	maintenanceLoadingComplete: false,
	loading: false,
	error: null,

	addMaintenanceLoading: false,
	updateMaintenanceLoading: false,
	deleteMaintenanceLoading: false
};

const maintenanceSlice = createSlice({
	name: 'maintenance',
	initialState,
	reducers: {
		loadMaintenanceLog(state) {
			state.loading = true;
			state.error = null;
		},
		loadMaintenanceLogSuccess(state, action) {
			state.loading = false;
			state.timeStamp = new Date();

			const orgID = action.payload.orgID;
			const oldData = state.data[orgID] || [];

			// Merge sites data using 'maintenanceID' as the unique identifier
			state.data[orgID] = mergeReduxStateData(oldData, action.payload.data, 'maintenanceID');

			state.maintenanceLoadingComplete = true;
		},
		loadMaintenanceLogError(state, action) {
			state.loading = false;
			state.error = action.payload;
		},
		addMaintenanceLog(state) {
			state.addMaintenanceLoading = true;
		},
		addMaintenanceLogSuccess(state) {
			state.addMaintenanceLoading = false;
		},
		addMaintenanceLogError(state, action) {
			state.addMaintenanceLoading = false;
			state.error = action.payload;
		},
		deleteMaintenanceLog(state) {
			state.deleteMaintenanceLoading = true;
		},
		deleteMaintenanceLogSuccess(state) {
			state.deleteMaintenanceLoading = false;
		},
		deleteMaintenanceLogError(state, action) {
			state.deleteMaintenanceLoading = false;
			state.error = action.payload;
		}
	}
});

export const maintenanceActions = maintenanceSlice.actions;

export default maintenanceSlice.reducer;
